import { mapGetters } from 'vuex';
import throttle from 'lodash/throttle';

export default {
    name: 'mvtShifter',
    props: {
        center: {
            type: Boolean,
            default: true,
        },
        theme: {
            type: String,
            default: 'default',
        },
        forceArrow: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        showArrow() {
            return !this.glb.isMobile || this.forceArrow;
        },
    },
    data() {
        return {
            hasNext: false,
            hasPrev: false,
            observer: null,
            mo: null,
        };
    },
    methods: {
        refresh() {
            this._updateWidth();
        },
        _updateWidth() {
            this.checkArrow();
        },
        checkArrow() {
            var $scroller = $(this.$el).find('[data-role="scroller"]');
            if (!this.showArrow) {
                return;
            }
            var scrollLeft = $scroller.scrollLeft();
            var innerWidth = $scroller.innerWidth();
            var scrollWidth = $scroller.prop('scrollWidth');
            if (scrollLeft + innerWidth >= scrollWidth - 10) {
                this.hasNext = false;
            } else {
                this.hasNext = true;
            }
            if (scrollLeft <= 10) {
                this.hasPrev = false;
            } else {
                this.hasPrev = true;
            }
        },
        _inital() {
            var $scroller = $(this.$el).find('[data-role="scroller"]');
            if (!$scroller[0]) {
                return;
            }
            this.refresh();
            $(document).on('dom.resize.' + this.vnumber, this._updateWidth);
            const config = { attributes: false, childList: true, subtree: false };
            this.mo = new MutationObserver(throttle(this.checkArrow, 150));
            if (this.mo) {
                this.mo.observe($scroller[0], config);
            }
            $scroller.on(
                'scroll',
                throttle(() => {
                    this.$emit('scroll');
                    this.checkArrow();
                }, 150)
            );
        },
        getOffset($el, next) {
            var offset = 0;
            var $scroller = $(this.$el).find('[data-role="scroller"]');
            let screenWidth = $scroller.innerWidth();
            $el.each(function (index, item) {
                var $this = $(item);
                var left = $this.position().left;
                var width = $this.outerWidth(true);
                if (next) {
                    if (left + width >= screenWidth) {
                        offset = left;
                        return false;
                    }
                } else {
                    if (left + width > -1) {
                        offset = screenWidth - left - width;
                        return false;
                    }
                }
            });
            return offset;
        },
        onNext() {
            if (!this.hasNext) {
                return;
            }
            const $scroller = $(this.$el).find('[data-role="scroller"]');
            const offset = this.getOffset($scroller.children(), true);
            const left = $scroller.scrollLeft();
            $scroller.scrollLeft(left + offset);
        },
        onPrev() {
            if (!this.hasPrev) {
                return;
            }
            const $scroller = $(this.$el).find('[data-role="scroller"]');
            const offset = this.getOffset($scroller.children(), false);
            const left = $scroller.scrollLeft();
            $scroller.scrollLeft(left - offset);
        },
    },
    beforeUnmount() {
        this.mo && this.mo.disconnect();
        $(document).off('dom.resize.' + this.vnumber);
    },
    mounted() {
        setTimeout(() => {
            this._inital();
        }, 1);
    },
};
